import { render, staticRenderFns } from "./zsszkb.vue?vue&type=template&id=71283188&scoped=true&"
import script from "./zsszkb.vue?vue&type=script&lang=js&"
export * from "./zsszkb.vue?vue&type=script&lang=js&"
import style0 from "./zsszkb.vue?vue&type=style&index=0&id=71283188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71283188",
  null
  
)

export default component.exports